"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interstitial = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function Interstitial({ html }) {
    return react_1.default.createElement("html", { dangerouslySetInnerHTML: { __html: html } });
}
exports.Interstitial = Interstitial;
